import Vue from "vue";
import Router from "vue-router";
import LandingPage from "@/templates/LandingPage.vue";
import Auth from "@/modules/Auth.js";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else if (
      to.path.includes("/s-app/group-page")
    ) {
      return { x: 0, y: 400 };
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes: [
    {
      path: "/",
      name: "landingPage",
      component: LandingPage,
    },
    {
      path: "/about-us",
      name: "AboutUs",
      component: () =>
        import(/* webpackChunkName: "about" */ "@/templates/AboutUs.vue"),
      meta: { noAuth: true },
    },
    // {
    //   path: "/garage-sales",
    //   name: "LandingGarageSalePage",
    //   component: () =>
    //     import(/* webpackChunkName: "about" */ "@/templates/GarageSalePage.vue"),
    //   meta: { noAuth: true },
    // },
    {
      path: "/bookmark2402",
      name: "BookmarkPage",
      component: () =>
        import(/* webpackChunkName: "about" */ "@/components/organisms/BookmarkPage.vue"),
      meta: { noAuth: true },
    },
    { path: '/s-app/bookmark2402', redirect: '/bookmark2402' },
    // {
    //   path: "/garage-sales-detail/:id",
    //   name: "LandingGarageSaleDetailUnlogged",
    //   component: () =>
    //     import(
    //       /* webpackChunkName: "about" */ "@/components/organisms/GarageSaleDetailUnlogged.vue"
    //     ),
    //     meta: { noAuth: true },
    // },
    {
      path: "/login",
      name: "loginPage",
      component: () =>
        import(/* webpackChunkName: "about" */ "@/templates/LoginPage.vue"),
      meta: { noAuth: true },
    },
    {
      path: "/signup",
      name: "registerPage",
      component: () =>
        import(/* webpackChunkName: "about" */ "@/templates/RegisterPage.vue"),
      meta: { noAuth: true },
    },
    {
      path: "/login-redirect",
      name: "loginRedirect",
      component: () =>
        import(/* webpackChunkName: "about" */ "@/templates/LoginRedirect.vue"),
    },
    {
      path: "/redirect",
      name: "redirect",
      component: () =>
        import(/* webpackChunkName: "about" */ "@/components/Redirect.vue"),
      meta: { noAuth: true },
    },
    {
      path: "/password-reset",
      name: "passwordreset",
      component: () =>
        import(
          /* webpackChunkName: "about" */ "@/material-components/organisms/PasswordResetMaterial.vue"
        ),
      meta: { noAuth: true },
    },
    {
      path: "/activation",
      name: "activation",
      component: () =>
        import(
          /* webpackChunkName: "about" */ "@/material-components/organisms/ActivationForm.vue"
        ),
      meta: { noAuth: true },
    },
    {
      path: "/search-result-landing/:query",
      name: "SSearchResultFromLandingPage",
      component: () =>
        import(
          /* webpackChunkName: "about" */ "@/components/organisms/SSearchResults.vue"
        ),
    },
    {
      path: "/item-details-landing/:id",
      name: "SItemDetailFromLandingPage",
      component: () =>
        import(
          /* webpackChunkName: "about" */ "@/components/organisms/SItemDetailFromLandingPage.vue"
        ),
      meta: { noAuth: true },
    },
    {
      path: "/contact-us",
      name: "ContactUs",
      meta: { noAuth: true },
      component: () =>
        import(/* webpackChunkName: "about" */ "@/templates/ContactUs.vue"),
    },
    {
      path: "/404",
      name: "404",
      meta: { noAuth: true },
      component: () => import("./views/Error404.vue")
    },
    { path: '*', redirect: '/404' },
    {
      path: "/footer",
      name: "footer",
      component: () =>
        import(/* webpackChunkName: "about" */ "@/templates/Footer.vue"),
    },
    {
      path: "/landing-page",
      name: "LandingPage",
      component: () =>
        import(/* webpackChunkName: "about" */ "@/templates/LandingPage.vue"),
    },
    {
      path: "/right-sticky-bar",
      name: "RightStickyBar",
      component: () =>
        import(
          /* webpackChunkName: "about" */ "@/templates/RightStickyBar.vue"
        ),
    },
    {
      path: "/header-group",
      name: "HeaderGroup",
      component: () =>
        import(
          /* webpackChunkName: "about" */ "@/components/organisms/HeaderGroup.vue"
        ),
    },
    {
      path: "/landing-help",
      name: "LandingHelp",
      component: () =>
        import(
          /* webpackChunkName: "about" */ "@/components/atoms/LandingHelp.vue"
        ),
      meta: { noAuth: true },
    },

    {
      path: "/:username",
      name: "",
      component: () =>
        import(/* webpackChunkName: "about" */ "@/templates/InventoryPage.vue"),
      children: [
        {
          path: "inventory",
          name: "InventoryItems",
          component: () =>
            import(
              /* webpackChunkName: "about" */ "@/components/molecules/InventoryItems.vue"
            ),
          children: [
            {
              path: ":category",
              name: "InventoryItemsCategory",
              component: () => import("@/components/molecules/InventoryItems.vue")
            }
          ],
        },
        {
          path: "groups",
          name: "ProfileGroups",
          component: () =>
            import(
              /* webpackChunkName: "about" */ "@/components/molecules/FavouriteGroups.vue"
            ),
        },
        {
          path: "settings",
          name: "ProfileSettings",
          component: () =>
            import(
              /* webpackChunkName: "about" */ "@/components/molecules/ProfileSettings.vue"
            ),
        },
      ],
      meta: { noAuth: true },
    },
    {
      path: "/s-app",
      component: () =>
        import(/* webpackChunkName: "bars" */ "@/views/Bars.vue"),
      children: [
        {
          path: "",
          name: "S-app",
          redirect: "feed",
        },
        {
          path: "contact-us",
          name: "AppContactUs",
          component: () =>
            import(/* webpackChunkName: "about" */ "@/templates/ContactUs.vue"),
        },
        {
          path: "help-center",
          name: "AppHelpCenter",
          component: () =>
            import(
              /* webpackChunkName: "about" */ "@/components/atoms/LandingHelp.vue"
            ),
        },
        {
          path: "terms-and-conditions",
          name: "AppTermsAndConditions",
          component: () =>
            import(
              /* webpackChunkName: "about" */ "@/templates/IframeTerms.vue"
            ),
        },
        {
          path: "privacy-policy",
          name: "AppPrivacyPolicy",
          component: () =>
            import(
              /* webpackChunkName: "about" */ "@/templates/IframePrivacy.vue"
            ),
        },
        {
          path: "feed",
          name: "Feed",
          component: () =>
            import(
              /* webpackChunkName: "newsfeed" */ "@/templates/NewsFeed.vue"
            ),
        },
        {
          path: "s-new-member",
          name: "SNewMembers",
          component: () =>
            import(
              /* webpackChunkName: "about" */ "@/components/organisms/SNewMember.vue"
            ),
        },
        {
          path: "item-details/:id",
          name: "SItemDetail",
          component: () =>
            import(
              /* webpackChunkName: "about" */ "@/components/organisms/SItemDetail.vue"
            ),
        },
        {
          path: "search-result",
          name: "SSearchResult",
          component: () =>
            import(
              /* webpackChunkName: "about" */ "@/components/organisms/SSearchResults.vue"
            ),
        },
        {
          path: "search-result/:query",
          name: "SSearchResultQuery",
          component: () =>
            import(
              /* webpackChunkName: "about" */ "@/components/organisms/SSearchResults.vue"
            ),
        },
        {
          path: "message-center",
          name: 'SMessageCenter',
          component: () => import(/* webpackChunkName: "about" */ '@/components/organisms/SMessageCenter.vue')
        },
        {
          path: "group-page/:id/",
          name: "",
          component: () =>
            import(/* webpackChunkName: "about" */ "@/templates/GroupPage.vue"),
          children: [
            {
              path: "",
              name: "GroupsTimeLine",
              component: () =>
                import(
                  /* webpackChunkName: "about" */ "@/components/organisms/ActivityList.vue"
                ),
            },
            {
              path: "membership",
              name: "GroupsMembership",
              component: () =>
                import(
                  /* webpackChunkName: "about" */ "@/components/molecules/GroupsMembership.vue"
                ),
            },
            {
              path: "items",
              name: "GroupsItems",
              component: () =>
                import(
                  /* webpackChunkName: "about" */ "@/components/molecules/GroupsItems.vue"
                ),
            },
            {
              path: "group-messages",
              name: "GroupMessages",
              component: () =>
                import(
                  /* webpackChunkName: "about" */ "@/components/molecules/GroupMessages.vue"
                ),
            },
            {
              path: "group-settings",
              name: "GroupSettings",
              component: () =>
                import(
                  /* webpackChunkName: "about" */ "@/components/molecules/GroupSettings.vue"
                ),
            },
          ],
        },

        {
          path: "profile-page/:id/",
          name: "ProfilePage",
          component: () =>
            import(/* webpackChunkName: "about" */ "@/templates/ProfilePage.vue"),
          children: [
            {
              path: "",
              name: "InventoryProfileItems",
              component: () =>
                import(
                  /* webpackChunkName: "about" */ "@/components/molecules/InventoryItems.vue"
                ),
            },
            {
              path: "groups",
              name: "InventoryProfileGroups",
              component: () =>
                import(
                  /* webpackChunkName: "about" */ "@/components/molecules/FavouriteGroups.vue"
                ),
            },
            {
              path: "settings",
              name: "InventoryProfileSettings",
              component: () =>
                import(
                  /* webpackChunkName: "about" */ "@/components/molecules/ProfileSettings.vue"
                ),
            },
            {
              path: "wishlist",
              name: "InventoryProfileWishlist",
              component: () =>
                import(
                  /* webpackChunkName: "about" */ "@/components/molecules/ProfileWishlist.vue"
                ),
            },
          ],
        },
        {
          path: "item-review",
          name: "itemReview",
          component: () =>
            import(
              /* webpackChunkName: "about" */ "@/components/organisms/ItemReview.vue"
            ),
        },
        {
          path: "item-activity",
          name: "MyPostArea",
          component: () =>
            import(
              /* webpackChunkName: "myPostArea" */ "@/components/organisms/MyPostArea.vue"
            ),
        },
        {
          path: "notifications",
          name: "MyNotifications",
          component: () =>
            import(
              /* webpackChunkName: "myNotifications" */ "@/components/organisms/NotificationArea.vue"
            ),
        },
        {
          path: "points-history",
          name: "PointsArea",
          component: () =>
            import(
              /* webpackChunkName: "myPostArea" */ "@/components/organisms/PointsArea.vue"
            ),
        },
        {
          path: "my-groups",
          name: "MyGroupsPage",
          component: () =>
            import(
              /* webpackChunkName: "myPostArea" */ "@/components/organisms/MyGroupsPage.vue"
            ),
        },
        {
          path: "invite-friends",
          name: "InviteFriendsPage",
          component: () =>
            import("@/material-components/organisms/InviteFriendsPage.vue"),
        },
        {
          path: "earn-swampum-points",
          name: "HowToEarnPoints",
          component: () =>
            import("@/material-components/organisms/HowToEarnPoints.vue"),
        },
        // {
        //   path: "garage-sales",
        //   name: "GarageSalePage",
        //   component: () =>
        //     import(/* webpackChunkName: "about" */ "@/templates/GarageSalePage.vue"),
        // },
        // {
        //   path: "garage-sales-detail/:id",
        //   name: "GarageSaleDetail",
        //   component: () =>
        //     import(
        //       /* webpackChunkName: "about" */ "@/components/organisms/GarageSaleDetail.vue"
        //     ),
        // },
        // {
        //   path: "add-garage-sales",
        //   name: "AddGarageSalePage",
        //   component: () =>
        //   import(
        //     /* webpackChunkName: "about" */ "@/components/organisms/AddGarageSales.vue"
        //   ),
        // },
      ],
      meta: { noAuth: false },
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (
    Auth.isUserAuthenticated() &&
    (to.path === "/login" || to.path === "/signup")
  ) {
    next({
      path: `/s-app/feed`,
    });
  }
  $('[data-toggle="tooltip"], [rel="tooltip"]').tooltip("hide");
  if (to.matched.some((record) => record.meta.noAuth)) {
    next();
  } else {
    if (!Auth.isUserAuthenticated() && to.path !== "/") {
      const routeToRedirect = to.fullPath.replace(
        "search-result-landing",
        "item-details-landing",
        "s-app"
      );
      switch (to.name) {
        case "SSearchResultFromLandingPage":
        case "SItemDetailFromLandingPage":
        case "loginRedirect":
          next();
          break;
        default:
          next({
            name: "loginRedirect",
            query: { redirect: routeToRedirect },
          });
          break;
      }
    } else if (
      Auth.isUserAuthenticated() &&
      (to.name === "loginPage" ||
        to.path === "/" ||
        to.name === "loginRedirect")
    ) {
      next({
        path: `/s-app/feed`,
      });
    } else {
      next();
    }
  }
});

export default router;
